import axios from "axios"
import {progressModalInitView, progressViewChange, progressModalHandler} from "../../common/progress_modal";
import {errorMessageAdd, errorMessageClear} from "../common/error_message";

let successCount = 0;
let failCount = 0;
const dayOfWeek = {
    'sunday': '日曜日',
    'monday': '月曜日',
    'tuesday': '火曜日',
    'wednesday': '水曜日',
    'thursday': '木曜日',
    'friday': '金曜日',
    'saturday': '土曜日'
} as any
const allCheckGbpLocation = () => {
    const locationGroupIndex = document.getElementById('location_group_index') as HTMLElement;
    const checkboxTh = document.getElementById('all_check_gbp_location_ids') as HTMLInputElement;
    checkboxTh.addEventListener('change', () => {
        const checkBoxTds = locationGroupIndex.querySelectorAll('td.check-box');
        checkBoxTds.forEach(checkBoxTd => {
            const checkbox = checkBoxTd.querySelector('input') as HTMLInputElement;
            checkbox.checked = checkboxTh.checked;
        });
    });
}

const toggleBulkUpdateForm = () => {
    const locationBulkUpdateFormToggle = document.querySelector('.gbp-location-bulk-update-form-toggle') as HTMLElement;
    locationBulkUpdateFormToggle.addEventListener('click', () => {
        const regularHoursitems = document.querySelector('.gbp-location-bulk-update-regular-hours-form-items') as HTMLElement;
        const specialHoursitems = document.querySelector('.gbp-location-bulk-update-special-hours-form-items') as HTMLElement;
        locationBulkUpdateFormToggle.classList.toggle('opened');
        regularHoursitems.style.display = locationBulkUpdateFormToggle.classList.contains('opened') ? 'block' : 'none';
        specialHoursitems.style.display = locationBulkUpdateFormToggle.classList.contains('opened') ? 'block' : 'none';
    });
}

const openHourHolidayCheckbox = () => {
    Object.keys(dayOfWeek).map((key) => {
        const checkbox = document.getElementById(`${key}_holiday_checkbox`) as HTMLInputElement;
        checkbox.addEventListener('change', () => {
            openHourHolidayCheckboxHandler(key, checkbox.checked);
        });
    })
}
const openHourHolidayCheckboxHandler = (dayOfWeek: string, checkboxChecked: boolean) => {
    ['open_time', 'close_time'].map((time) => {
        const timeId = document.getElementById(`${dayOfWeek}_${time}`) as HTMLInputElement;
        timeId.disabled = checkboxChecked;
        timeId.value = '';
        if (!checkboxChecked) {
            timeId.value = (time == 'open_time') ? '09:00' : '21:00';
        }
    })
}
const locationBulkUpdateButtonActive = () => {
    const locationGroupIndex = document.getElementById('location_group_index') as HTMLElement;
    const locationBulkUpdateRegularHoursButtonDiv = document.querySelector('.gbp-location-bulk-update-regular-hours-button') as HTMLElement;
    const locationBulkUpdateRegularHoursButton = locationBulkUpdateRegularHoursButtonDiv.querySelector('[type="submit"]') as HTMLButtonElement;
    const locationBulkUpdateSpecialHoursButtonDiv = document.querySelector('.gbp-location-bulk-update-special-hours-button') as HTMLElement;
    const locationBulkUpdateSpecialHoursButton = locationBulkUpdateSpecialHoursButtonDiv.querySelector('[type="submit"]') as HTMLButtonElement;
    locationBulkUpdateRegularHoursButton.disabled = true;
    locationBulkUpdateSpecialHoursButton.disabled = true;
    const locationCheckboxTds = locationGroupIndex.querySelectorAll('td.check-box');
    locationCheckboxTds.forEach(locationCheckboxTd => {
        locationCheckboxTd.addEventListener('change', () => {
            locationBulkUpdateButtonChange(locationBulkUpdateRegularHoursButton, locationCheckboxTds)
            locationBulkUpdateButtonChange(locationBulkUpdateSpecialHoursButton, locationCheckboxTds)
        });
    });
    const locationCheckboxTh = document.getElementById('all_check_gbp_location_ids') as HTMLInputElement;
    locationCheckboxTh.addEventListener('change', () => {
        locationBulkUpdateButtonChange(locationBulkUpdateRegularHoursButton, locationCheckboxTds)
        locationBulkUpdateButtonChange(locationBulkUpdateSpecialHoursButton, locationCheckboxTds)
    });
}
const locationBulkUpdateButtonChange = (button: HTMLButtonElement, checkboxTds: NodeListOf<Element>) => {
    button.disabled = true;
    checkboxTds.forEach(checkboxTd => {
        const checkbox = checkboxTd.querySelector('input') as HTMLInputElement;
        if (checkbox.checked) {
            button.disabled = false;
            return
        }
    });
}
const fetchBulkUpdateLocations = () => {
    const locationGroupIndex = document.getElementById('location_group_index') as HTMLElement;
    const checkBoxTds = locationGroupIndex.querySelectorAll('td.check-box');
    const locationNames = [] as string[];
    checkBoxTds.forEach(checkBoxTd => {
        const checkbox = checkBoxTd.querySelector('input') as HTMLInputElement;
        if (checkbox.checked) {
            locationNames.push(checkbox.value)
        }
    });
    return locationNames;
}
const fetchParamsLocationBulkUpdate = () => {
    const params = {} as any;
    Object.keys(dayOfWeek).map((key) => {
        ['open_time', 'close_time', 'holiday_checkbox'].map((tag) => {
            const element = document.getElementById(`${key}_${tag}`) as HTMLInputElement;
            params[`${key}_${tag}`] = (tag == 'holiday_checkbox') ? element.checked : element.value;
        })
        // validation
        if (!params[`${key}_holiday_checkbox`]) {
            if (params[`${key}_open_time`] == '' || params[`${key}_close_time`] == '') {
                errorMessageAdd(`${dayOfWeek[key]}の営業時間が入力されていません。`)
            }
            const [open_time_hours, open_time_minutes] = params[`${key}_open_time`].split(':').map(Number);
            const [close_time_hours, close_time_minutes] = params[`${key}_close_time`].split(':').map(Number);
            if ((open_time_hours * 60 + open_time_minutes) >= (close_time_hours * 60 + close_time_minutes)) {
                errorMessageAdd(`${dayOfWeek[key]}の営業時間が正しくありません。`)
            }
        }
    })
    return params;
}

const submitLocationBulkUpdate = () => {
    const locationBulkUpdateRegularHoursButtonDiv = document.querySelector('.gbp-location-bulk-update-regular-hours-button') as HTMLElement;
    const locationBulkUpdateButton = locationBulkUpdateRegularHoursButtonDiv.querySelector('[type="submit"]') as HTMLButtonElement;
    locationBulkUpdateButton.addEventListener('click', () => {
        if (!window.confirm('一括更新(営業時間)を実行しますか？')) {
            return
        }
        errorMessageClear()
        const locationNames: string[] = fetchBulkUpdateLocations()
        const params = fetchParamsLocationBulkUpdate()
        const errorMessageUl = document.querySelector('ul.gbp-error-message') as HTMLElement;
        if (errorMessageUl.childElementCount == 0) {
            [successCount, failCount] = progressModalInitView()
            locationNames.map((locationName) => {
                submitLocationBulkUpdateRequest(locationName, params, locationNames.length)
            })
        }
    });
}
const submitLocationBulkUpdateRequest = (locationName: string, params: any, baseCount: number) => {
    const token = (document.getElementsByName('csrf-token')[0] as HTMLElement).getAttribute('content');
    const url = `/staff/api/gbp/locations/${encodeURIComponent(locationName)}`
    const config = {headers: {'X-CSRF-Token': token}}
    axios.patch(url, params, config)
        .then(response => {
            const data = response.data;
            if (data['result']) {
                successCount += 1;
            } else {
                errorMessageAdd(data['message'])
                failCount += 1;
            }
            progressViewChange(successCount, failCount, baseCount)
        }).catch(error => {
        errorMessageAdd('エラーが発生しました。')
        failCount += 1;
        progressViewChange(successCount, failCount, baseCount)
    });
}


const submitLocationBulkSpecialHoursUpdate = () => {
    const locationBulkUpdateSpecialHoursButtonDiv = document.querySelector('.gbp-location-bulk-update-special-hours-button') as HTMLElement;
    const locationBulkUpdateButton = locationBulkUpdateSpecialHoursButtonDiv.querySelector('[type="submit"]') as HTMLButtonElement;
    locationBulkUpdateButton.addEventListener('click', () => {
        if (!window.confirm('一括更新(特別営業時間)を実行しますか？')) {
            return
        }
        errorMessageClear()
        const locationNames: string[] = fetchBulkUpdateLocations()
        const params = fetchParamsLocationBulkUpdateSpecialHours()
        const errorMessageUl = document.querySelector('ul.gbp-error-message') as HTMLElement;
        if (errorMessageUl.childElementCount == 0) {
            [successCount, failCount] = progressModalInitView()
            locationNames.map((locationName) => {
                submitLocationBulkUpdateSpecialHoursRequest(locationName, params, locationNames.length)
            })
        }
    });
}

const fetchParamsLocationBulkUpdateSpecialHours = () => {
    const params = {} as any;
    params['special_hours'] = {}
    const specialHoursDivs = document.querySelectorAll('.special-hour');
    if (specialHoursDivs.length <= 0) {
        errorMessageAdd('特別営業時間を追加してください。')
    }
    specialHoursDivs.forEach((element) => {
        console.log(element)
        const specialHourActionAdd = element.querySelector('.special-hour-action-add') as HTMLInputElement;
        const specialHourActionDelete = element.querySelector('.special-hour-action-delete') as HTMLInputElement;
        const selectedAction = specialHourActionAdd.checked ? specialHourActionAdd.value : (specialHourActionDelete.checked ? specialHourActionDelete.value : '');
        const date = (element.querySelector('.special_hour_date') as HTMLInputElement).value;
        const openTime = (element.querySelector('.special_hour_open_time') as HTMLInputElement).value;
        const closeTime = (element.querySelector('.special_hour_close_time') as HTMLInputElement).value;
        const closed = (element.querySelector('.special-hour-closed-checkbox') as HTMLInputElement).checked;

        // validation
        if (!date) {
            errorMessageAdd('特別営業時間の日付が入力されていません。')
        }
        if (specialHourActionAdd.checked && !closed) {
            if (openTime == '' || closeTime == '') {
                errorMessageAdd(`${date}の特別営業時間が入力されていません。`)
            }
            const [open_time_hours, open_time_minutes] = openTime.split(':').map(Number);
            const [close_time_hours, close_time_minutes] = closeTime.split(':').map(Number);
            if ((open_time_hours * 60 + open_time_minutes) >= (close_time_hours * 60 + close_time_minutes)) {
                errorMessageAdd(`${date}の特別営業時間が正しくありません。`)
            }
        }

        params['special_hours'][date] = {
            action: selectedAction,
            open_time: openTime,
            close_time: closeTime,
            closed: closed
        }
    })
    return params;
}
const submitLocationBulkUpdateSpecialHoursRequest = (locationName: string, params: any, baseCount: number) => {
    const token = (document.getElementsByName('csrf-token')[0] as HTMLElement).getAttribute('content');
    const url = `/staff/api/gbp/locations/${encodeURIComponent(locationName)}/special_hours`
    const config = {headers: {'X-CSRF-Token': token}}
    axios.patch(url, params, config)
        .then(response => {
            const data = response.data;
            if (data['result']) {
                successCount += 1;
            } else {
                errorMessageAdd(data['message'])
                failCount += 1;
            }
            progressViewChange(successCount, failCount, baseCount)
        }).catch(error => {
        errorMessageAdd('エラーが発生しました。')
        failCount += 1;
        progressViewChange(successCount, failCount, baseCount)
    });
}

const specialHoursCheckbox = () => {
    const specialHoursDivs = document.querySelectorAll('.special-hour');
    specialHoursDivs.forEach((element) => {
        const checkbox = element.querySelector('.special-hour-closed-checkbox') as HTMLInputElement;
        checkbox.addEventListener('change', () => {
            specialHoursCheckboxHandler(element, checkbox.checked);
        });
    })
}

const specialHoursCheckboxHandler = (element: Element, checkboxChecked: boolean) => {
    ['open_time', 'close_time'].map((time) => {
        const TimeElement = element.querySelector(`.special_hour_${time}`) as HTMLInputElement;
        TimeElement.disabled = checkboxChecked;
        TimeElement.value = '';
        if (!checkboxChecked) {
            TimeElement.value = (time == 'open_time') ? '09:00' : '21:00';
        }
    })
}

const deleteSpecialHour = () => {
    const specialHoursDivs = document.querySelectorAll('.special-hour');
    specialHoursDivs.forEach((element) => {
        const deleteIcon = element.querySelector('.delete_special_hour') as HTMLInputElement;
        deleteIcon.addEventListener('click', () => {
            element.remove()
        });
    })
}

const specialHourAction = () => {
    const specialHoursDivs = document.querySelectorAll('.special-hour');
    specialHoursDivs.forEach((element) => {
        const specialHourActionAdd = element.querySelector('.special-hour-action-add') as HTMLInputElement;
        specialHourActionAdd.addEventListener('click', () => {
            (element.querySelector('.special_hour_open_time') as HTMLInputElement).style.display = 'inline';
            (element.querySelector('.special_hour_separator') as HTMLInputElement).style.display = 'inline';
            (element.querySelector('.special_hour_close_time') as HTMLInputElement).style.display = 'inline';
            (element.querySelector('.special-hour-closed-checkbox') as HTMLInputElement).style.display = 'inline';
            (element.querySelector('.special-hour-closed-label') as HTMLInputElement).style.display = 'inline';
        });
        const specialHourActionDelete = element.querySelector('.special-hour-action-delete') as HTMLInputElement;
        specialHourActionDelete.addEventListener('click', () => {
            (element.querySelector('.special_hour_open_time') as HTMLInputElement).style.display = 'none';
            (element.querySelector('.special_hour_separator') as HTMLInputElement).style.display = 'none';
            (element.querySelector('.special_hour_close_time') as HTMLInputElement).style.display = 'none';
            (element.querySelector('.special-hour-closed-checkbox') as HTMLInputElement).style.display = 'none';
            (element.querySelector('.special-hour-closed-label') as HTMLInputElement).style.display = 'none';
        });
    })
}
const addSpecialHour = () => {
    const addButton = document.getElementById('add_special_hour') as HTMLButtonElement;
    addButton.addEventListener('click', () => {
        const specialHoursElement = document.querySelector('.special-hours');
        if(specialHoursElement){
            addSpecialHourHandler(specialHoursElement);
            specialHoursCheckbox()
            deleteSpecialHour()
            specialHourAction()
        }
    });
}

const addSpecialHourHandler = (element: Element) => {
    const indexElement = document.getElementById('special_hour_index') as HTMLInputElement
    if (indexElement) {
        let index = parseInt(indexElement.value);
        index += 1;
        indexElement.value = (index).toString();
        element.appendChild(specialHourDivElement(index));
    }
}

const specialHourDivElement = (index: number) => {
    const div = document.createElement('div');

    div.classList.add('special-hour');
    div.id = `special_hour_${index}`;

    const addRadioButton = document.createElement('input');
    addRadioButton.type = 'radio';
    addRadioButton.name = `special_hour_action_${index}`;
    addRadioButton.id = `special_hour_action_${index}_add`;
    addRadioButton.value = 'add';
    addRadioButton.classList.add('special-hour-action-add');
    addRadioButton.checked = true;
    const addLabel = document.createElement('label');
    addLabel.htmlFor = 'special_hour_action_add';
    addLabel.textContent = '追加';
    div.appendChild(addRadioButton);
    div.appendChild(addLabel);

    const deleteRadioButton = document.createElement('input');
    deleteRadioButton.type = 'radio';
    deleteRadioButton.name = `special_hour_action_${index}`;
    deleteRadioButton.id = `special_hour_action_${index}_delete`;
    deleteRadioButton.value = 'delete';
    deleteRadioButton.classList.add('special-hour-action-delete');
    const deleteLabel = document.createElement('label');
    deleteLabel.htmlFor = 'special_hour_action_delete';
    deleteLabel.textContent = '削除';
    div.appendChild(deleteRadioButton);
    div.appendChild(deleteLabel);

    const dateInput = document.createElement('input');
    dateInput.type = 'date';
    dateInput.name = `special_hour_date_${index}`;
    dateInput.id = `special_hour_date_${index}`;
    dateInput.value = '';
    dateInput.classList.add('form-control', 'special_hour_date');
    div.appendChild(dateInput);

    const openTimeInput = document.createElement('input');
    openTimeInput.type = 'time';
    openTimeInput.name = `special_hour_open_time_${index}`;
    openTimeInput.id = `special_hour_open_time_${index}`;
    openTimeInput.value = '';
    openTimeInput.disabled = true;
    openTimeInput.classList.add('form-control', 'special_hour_open_time');
    div.appendChild(openTimeInput);

    const separatorSpan = document.createElement('span');
    separatorSpan.textContent = '〜';
    separatorSpan.classList.add('special_hour_separator');

    div.appendChild(separatorSpan);

    const closeTimeInput = document.createElement('input');
    closeTimeInput.type = 'time';
    closeTimeInput.name = `special_hour_close_time_${index}`;
    closeTimeInput.id = `special_hour_close_time_${index}`;
    closeTimeInput.value = '';
    closeTimeInput.disabled = true;
    closeTimeInput.classList.add('form-control', 'special_hour_close_time');
    div.appendChild(closeTimeInput);

    const closedCheckbox = document.createElement('input');
    closedCheckbox.type = 'checkbox';
    closedCheckbox.name = `special_hour_closed_checkbox_${index}`;
    closedCheckbox.id = `special_hour_closed_checkbox_${index}`;
    closedCheckbox.value = 'true';
    closedCheckbox.classList.add('special-hour-closed-checkbox');
    closedCheckbox.checked = true;
    const closedLabel = document.createElement('label');
    closedLabel.htmlFor = 'special_hour_closed';
    closedLabel.textContent = '休業';
    closedLabel.classList.add('special-hour-closed-label');
    div.appendChild(closedCheckbox);
    div.appendChild(closedLabel);

    const trashIcon = document.createElement('i');
    trashIcon.classList.add('fa', 'fa-trash', 'delete_special_hour');
    div.appendChild(trashIcon);

    return div
}
document.addEventListener('DOMContentLoaded', () => {

    const locationGroupIndex = document.getElementById('location_group_index') as HTMLElement;
    if (locationGroupIndex == null) {
        return;
    }

    allCheckGbpLocation()
    toggleBulkUpdateForm()
    openHourHolidayCheckbox()
    submitLocationBulkUpdate()
    locationBulkUpdateButtonActive()
    progressModalHandler()
    addSpecialHour()
    submitLocationBulkSpecialHoursUpdate()

});
